export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-bold-web-476130ca9a5cf19641bec37188b7bb44.svg";